import http from '@/common/request/axios';

export const transactionService = {
    text: {
        list({ offset, limit, locale }: any) {
            return http.doGet('admin/transaction/text/' + locale, { offset, limit });
        },

        getContent(code: string, locale: string) {
            return http.doGet('admin/transaction/text/' + code + '/' + locale);
        },

        updateContent(code: string, locale: string, content: string) {
            return http.doPut('admin/transaction/text/' + code + '/' + locale, {
                content: content
            });
        },

        export() {
            return http.doGet('admin/transaction/text/export');
        },

        import(file: any) {
            return http.doPost(
                'admin/transaction/text/import',
                {},
                {
                    file: file
                }
            );
        }
    }
};
